export default __webpack_public_path__ + "static/media/people.122cc3ed.svg";